export type PlayerNameMatch = {
  id: string;
  name: string;
  teams: { id: string; name: string; season?: string; status?: string }[];
};

/** Shared save-time decision for every Portal/mobile creation entry point. */
export function choosePlayerNameMatch(matches: PlayerNameMatch[], teamId?: string, standIn = false): Promise<string | null> {
  if (!matches.length) return Promise.resolve(null);
  return new Promise((resolve, reject) => {
    const previousFocus = document.activeElement as HTMLElement | null;
    const dialog = document.createElement('dialog');
    dialog.setAttribute('aria-label', 'Mogelijk bestaande speler');
    Object.assign(dialog.style, { width: 'min(540px, calc(100vw - 32px))', maxHeight: '85vh', padding: '24px', border: '1px solid #ddd', borderRadius: '12px', color: '#17212b', background: 'white', overflowY: 'auto' });
    const addText = (tag: string, value: string) => {
      const element = document.createElement(tag); element.textContent = value; dialog.append(element); return element;
    };
    addText('h2', 'Mogelijk bestaat deze speler al binnen de club');
    addText('p', 'Controleer of dit dezelfde persoon is. Een bestaande speler behoudt alle gegevens en eerdere teamkoppelingen.');
    const finish = (id: string | null | undefined) => {
      dialog.close(); dialog.remove(); previousFocus?.focus();
      if (id === undefined) reject(new Error('Speler toevoegen geannuleerd')); else resolve(id);
    };
    const button = (label: string, action: () => void, disabled = false) => {
      const element = document.createElement('button'); element.type = 'button'; element.textContent = label;
      element.disabled = disabled;
      Object.assign(element.style, { minHeight: '44px', padding: '8px 12px', margin: '8px 8px 8px 0', border: '1px solid #d1d5db', borderRadius: '6px', background: 'white', cursor: disabled ? 'default' : 'pointer', opacity: disabled ? '.5' : '1' });
      element.addEventListener('click', action); dialog.append(element);
    };
    for (const player of matches) {
      addText('h3', player.name);
      addText('p', player.teams.length ? player.teams.map(team => `${team.name} · ${team.season || 'Seizoen ontbreekt'}`).join(' / ') : 'Zonder team · clublid');
      const own = player.teams.some(team => team.id === teamId);
      const eligible = !standIn || (!own && player.teams.some(team => team.status === 'active'));
      button(own ? 'Zit al in dit team — bestaande speler gebruiken' : 'Bestaande speler gebruiken', () => finish(player.id), !eligible);
      if (!eligible) addText('p', 'Invallen kan alleen vanuit een ander team van het actieve seizoen.');
    }
    if (!standIn) button('Toch een nieuwe speler aanmaken', () => finish(null));
    else addText('p', 'Nieuwe speler? Voeg die eerst toe aan het eigen team en selecteer die daarna als invaller.');
    button('Annuleren', () => finish(undefined));
    dialog.addEventListener('cancel', event => { event.preventDefault(); finish(undefined); });
    document.body.append(dialog); dialog.showModal();
  });
}
